import { render } from "./FooterMain.vue?vue&type=template&id=03b98465"
const script = {}

import "./FooterMain.vue?vue&type=style&index=0&id=03b98465&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__